export default __webpack_public_path__ + "static/media/61895138_2188282457927832_279703349945696256_n.8d7cad7f.jpg";